import { useEffect, useState } from "react";
import _ from "lodash";
import { useDispatchApp } from "../../lib/redux";
import { startGetAdvertiserDefaultPlatformValues } from "../../actions/platformDefaults";
import { applyPlatformDefaultsToGenerateCampaign } from "./applyPlatformDefaultsToGenerateCampaign";

export const usePlatformDefaultsInGenerateCampaign = ({
  platform,
  setValue,
}) => {
  const dispatch = useDispatchApp();
  const [isLoadingDefaults, setIsLoadingDefaults] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadPlatformDefaults = async () => {
      setIsLoadingDefaults(true);

      const result = await dispatch(
        startGetAdvertiserDefaultPlatformValues({ platform })
      );

      if (!isMounted) {
        return;
      }

      if (result?.ok && result.data && !_.isEmpty(result.data)) {
        applyPlatformDefaultsToGenerateCampaign({
          platform,
          data: result.data,
          setValue,
        });
      }

      setIsLoadingDefaults(false);
    };

    loadPlatformDefaults();

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [platform, dispatch]);

  return { isLoadingDefaults };
};
